export default __webpack_public_path__ + "da2ebe916b6afbfc16db0208c2c512d7.svg";